export default {"src":"/_next/static/media/icon_arrow_right_up.1292a385.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};